














/**
 * 已捐公益印花统计数据
 */
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  name: 'NgoStatis',
  props: {
    todyCount: {
      type: Number,
      default: 0,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
  },
});
